import WidgetBox from "components/elements/WidgetBox/widget-box";
import {
  Flex,
  Stack,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Thead,
  Tr,
  Checkbox,
  HStack,
} from "@chakra-ui/react";
import payments from "../../mocks/payments.json";
import { useCustomFormats } from "hooks/useCustomFormat";
import React from "react";
import { StatusFilter } from "../status-filter";
import { ActionButton } from "../action-button";
import { ExportButton } from "../export-button";
import { ColumnsButton } from "../columns-button";
import { ThSort } from "./components/th-sort";
import { ThCheckbox } from "./components/th-checkbox";
import { TdStatus } from "./components/td-status";
import { TdActions } from "./components/td-actions";
import { ThActions } from "./components/th-actions";
import { TdCheckbox } from "./components/td-checkbox";

export function PaymentsTable() {
  const { formatDate, formatCurrency } = useCustomFormats();
  const [selectedStatus, setSelectedStatus] = React.useState<string>("all");

  const SubTitle = () => (
    <Text fontWeight="normal" color="#6C6B6E" mt={-2}>
      Payments include credit and debit card sales, captures, and eChecks (ACH).
    </Text>
  );

  const TableFiltersAndActions = () => {
    const statuses = [
      { value: "all", label: "All" },
      { value: "Succeeded", label: "Succeeded" },
      { value: "Failed", label: "Failed" },
      { value: "Pending", label: "Pending" },
      { value: "Canceled", label: "Canceled" },
    ];

    return (
      <Flex justifyContent="space-between" gap={2}>
        <StatusFilter statuses={statuses} value={selectedStatus} onChange={setSelectedStatus} />
        <HStack gap={2}>
          <ColumnsButton />
          <ExportButton />
          <ActionButton />
        </HStack>
      </Flex>
    );
  };

  const TableData = () => {
    const filteredPayments = payments.filter(
      payment => selectedStatus === "all" || payment.status === selectedStatus
    );

    return (
      <TableContainer>
        <Table>
          <Thead>
            <Tr>
              <ThCheckbox />
              <ThSort>ID</ThSort>
              <ThSort>Created On</ThSort>
              <ThSort>Buyer Name</ThSort>
              <ThSort>Amount</ThSort>
              <ThSort>Status</ThSort>
              <ThSort>Payment Instrument</ThSort>
              <ThActions />
            </Tr>
          </Thead>
          <Tbody>
            {filteredPayments.map(payment => (
              <Tr key={payment.id}>
                <TdCheckbox />
                <Td>{payment.id}</Td>
                <Td>{formatDate(payment.createdOn)}</Td>
                <Td>{payment.buyerName}</Td>
                <Td fontWeight="bold">{formatCurrency(payment.amount)}</Td>
                <TdStatus status={payment.status} failureReason={payment.failureReason} />
                <Td>{payment.paymentInstrument}</Td>
                <TdActions />
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    );
  };

  return (
    <WidgetBox title="Payments">
      <Stack gap={6}>
        <SubTitle />
        <TableFiltersAndActions />
        <TableData />
      </Stack>
    </WidgetBox>
  );
}
